import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { LoadMoreStoriesBase, LoadMoreCollectionStories } from "@quintype/components";

import { OneMainCardSlider } from "../layout/one-main-card-slider.js";
import { FullscreenStoryList } from "../layout/fullscreen-story-list.js";
import { ThreeStoryCards } from "../layout/three-story-cards.js";
import { OneStoryCardSixStoryList } from "../layout/onestorycard-sixstorylist.js";
import { CardGroup } from "../layout/card-group.js";

class SectionPageBase extends React.Component {
  render() {
    const stories = this.props.data.collection.items;
    return <LoadMoreStories {...this.props} stories={stories} languageDirection={get(this.props.config, ['theme-attributes', 'language_direction'], "left")} />
  }
}

function getCollectionConfig(collection, section) {
  return {
      'name': section['display-name'] || section['name'],
      'collection-name': section['display-name'] || section['name'],
      'collection-slug': collection.slug,
      'collection-color': collection.color
    }
}

function LoadMoreStoriesTemplate(props) {
  const config = getCollectionConfig(props.collection, props.section);
  return <div>
    <h1 style={{display: 'none'}}>{config['name']}</h1>
    <CardGroup stories={props.stories.slice(0,4)} config= {config}/>
    <OneMainCardSlider stories={props.stories.slice(4,9)} config= {config}/>
    <ThreeStoryCards stories={props.stories.slice(9,12)} config= {config}/>
    <OneStoryCardSixStoryList stories={props.stories.slice(12,19)} config= {config}/>
    <FullscreenStoryList adSlot={true}
        config= {config}
        stories={props.stories.slice(19)}
        onLoadMore={props.onLoadMore}
        noMoreStories={props.noMoreStories} />
  </div>;
}

function LoadMoreStories(props) {
  const collection = get(props, ['data', 'section', 'collection'], null);
  const storyFields = 'headline,subheadline,summary,sections,tags,author-name,author-id,authors,updated-at,last-published-at,published-at,updated-at,first-published-at,hero-image-metadata,hero-image-s3-key,story-content-id,slug,id,seo,story-template';
  const data = Object.assign({}, props.data, {stories: props.stories});
  const sectionId = get(props, ['data', 'section', 'id'], -1);
  const numStoriesToLoad = 10;
  
  return collection ?
    <LoadMoreCollectionStories template={LoadMoreStoriesTemplate}
      collectionSlug={collection.slug}
      params={{ 'item-type': 'story' }}
      data={data}
      languageDirection={props.languageDirection}
      numStoriesToLoad={numStoriesToLoad} /> :
    <LoadMoreStoriesBase template={LoadMoreStoriesTemplate}
      fields={storyFields}
      params={{ 'section-id': sectionId }}
      data={data}
      languageDirection={props.languageDirection}
      numStoriesToLoad={numStoriesToLoad} />;
}

function mapStateToProps(state) {
  return {
    config: state.qt.config
  }
}

export const SectionPage = connect(mapStateToProps)(SectionPageBase);
